import { isCurrentCultureRightToLeft } from 'owa-localize';
import type { ActionSource } from 'owa-timestream-store';
import { ASSUMED_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import type { AssetOrAssetsFromClipboardData } from 'owa-timestream-asset-sdk-types';

import createAssetOnPageCoordinates from './createAssetOnPageCoordinates';

export default function createAssetsFromClipboardData(
    actionSource: ActionSource,
    assetOrAssets: AssetOrAssetsFromClipboardData,
    x: number,
    y: number
) {
    if (assetOrAssets) {
        const assets = Array.isArray(assetOrAssets) ? assetOrAssets : [assetOrAssets];
        assets.forEach(asset => {
            if (asset) {
                // $TODO: add heuristic to avoid adding objects on top of existing ones.
                createAssetOnPageCoordinates(x, y, asset, actionSource);

                // Paste them horizontally since we don't know the height of most assets.
                x += isCurrentCultureRightToLeft() ? -ASSUMED_ASSET_WIDTH : ASSUMED_ASSET_WIDTH;
            }
        });
    }
}
